<template>
    <div class="presentation-mode">
        <div class="header">
            <b-button
                class="btn-return-back"
                v-b-tooltip.hover
                variant="primary"
                v-if="$authUser.isTeacher() || $authUser.isAdmin()"
                :title="$t('presentation.show.back.button')"
                @click="backToWhereYouCamefrom">
                <i class="far fa-level-down fa-rotate-90 "></i>
            </b-button>

            <b-button
                class="btn-fullscreen"
                v-b-tooltip.hover
                variant="primary"
                :title="$t('presentation.show.fullscreen.button')"
                @click="toggleFullScreen">
                <i class="far fa-expand"></i>
            </b-button>
        </div>

        <b-button
            class="btn-chevron-left btn-previous-slide"
            variant="primary"
            :disabled="selectedSlide.order < 2"
            @click="previousSlide">
        </b-button>

        <design-2021-show-slide-component
            @next-slide="nextSlide"
            @previous-slide="previousSlide"
            @exit-fullscreen="toggleFullScreen"
            ref="slideComponent"
            :slide-in="selectedSlide"
            :slide-collection="slideCollection">
        </design-2021-show-slide-component>

        <b-button
            class="btn-chevron-right btn-next-slide"
            variant="primary"
            :disabled="selectedSlide.order >= slideCollection.length"
            @click="nextSlide">
        </b-button>
    </div>
</template>

<script>
    export default {
        name: 'design-2021-lesson-manual-presentation-component',
        props: {
            styleIn: {
                type: String,
                default: 'default',
                required: false
            },
            lessonIn: {
                type: Object,
                required: true
            },
            slideIdIn: {
                type: [Number, Object],
                required: false
            }
        },
        data() {
            return {
                selectedSlideId: this.slideIdIn > 0 ? this.slideIdIn : this.lessonIn.presentation.steps[0].slides[0].id
            };
        },
        computed: {
            slideCollection() {
                let slides = [];
                let count = 0;

                for (const step of this.lessonIn.presentation.steps) {
                    for (const slide of step.slides) {
                        count++;
                        slide.order = count;
                        slides.push(slide);
                    }
                }

                return slides;
            },
            selectedSlide() {
                return this.slideCollection.find((slide) => slide.id === this.selectedSlideId);
            }
        },
        methods: {
            nextSlide() {
                this.selectedSlideId = this.slideCollection.find(
                    (slide) => slide.order === this.selectedSlide.order + 1
                ).id;
            },
            previousSlide() {
                this.selectedSlideId = this.slideCollection.find(
                    (slide) => slide.order === this.selectedSlide.order - 1
                ).id;
            },
            toggleFullScreen() {
                const element = this.$refs.slideComponent.$el;
                if (!document.fullscreenElement) {
                    element.requestFullscreen();
                } else {
                    document.exitFullscreen();
                }
            },
            backToWhereYouCamefrom() {
                if (this.lessonIn.group_id) {
                    window.location.href = this.routes.groupShow(this.lessonIn.group_id);
                } else {
                    window.location.href = this.routes.lessonModuleShow(this.lessonIn.lesson_module_id);
                }
            }
        }
    };
</script>

<style scoped lang="scss">
    .presentation-mode {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: center;
        row-gap: map-get($grid-gutter-spacing, 'fifteen');
    }

    .header {
        display: flex;
        justify-content: space-between;
        column-gap: $grid-gutter-width;
        align-items: flex-start;
        flex: 1 0 100%;
    }

    .btn-return-back,
    .btn-fullscreen,
    .btn-previous-slide,
    .btn-next-slide {
        display: flex;
        justify-content: center;
        align-items: center;
        align-self: center;
        line-height: 1;
        height: 30px;
        width: 30px;
        border-radius: $border-radius-sm;
        font-size: 1rem;
        padding: map-get($grid-gutter-spacing, 'eight') map-get($grid-gutter-spacing, 'ten');

        &:before {
            margin-right: 0;
            width: auto;
        }
    }

    .btn-previous-slide {
        position: absolute;
        left: 15px;
        z-index: 10;
    }

    .btn-next-slide {
        position: absolute;
        right: 15px;
        z-index: 10;
    }

    @media(min-width: map-get($grid-breakpoints, 'md')) {
        .btn-return-back,
        .btn-fullscreen,
        .btn-previous-slide,
        .btn-next-slide {
            height: 50px;
            width: 50px;
            border-radius: 8px;
            font-size: 2rem;
        }

        .btn-previous-slide {
            left: map-get($grid-gutter-spacing, 'fifteen');
        }

        .btn-next-slide {
            right: map-get($grid-gutter-spacing, 'fifteen');
        }
    }

    @media(min-width: map-get($grid-breakpoints, 'lg')) {
        .btn-previous-slide {
            left: 35px;
        }

        .btn-next-slide {
            right: 35px;
        }
    }

    @media(min-width: map-get($grid-breakpoints, 'xl')) {
        .btn-return-back,
        .btn-fullscreen,
        .btn-previous-slide,
        .btn-next-slide {
            height: 64px;
            width: 64px;
            border-radius: $border-radius-content;
            font-size: 3rem;
            padding: map-get($grid-gutter-spacing, 'ten') map-get($grid-gutter-spacing, 'fifteen');
        }

        .btn-previous-slide {
            position: relative;
            left: unset;
            margin-right: $grid-gutter-width;
        }

        .btn-next-slide {
            position: relative;
            right: unset;
            margin-left: $grid-gutter-width;
        }
    }
</style>
